var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HistoryQueries',{class:_vm.baseClass,attrs:{"max-items-to-render":_vm.maxItemsToRender},scopedSlots:_vm._u([{key:"suggestion-content",fn:function({ suggestion }){return [_c('span',{class:`${_vm.baseClass}__icon eicon`},[_vm._v("historical")]),_vm._v("\n    "+_vm._s(suggestion.query)+"\n  ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }